import { render, staticRenderFns } from "./DashboardUsageChart.vue?vue&type=template&id=f96e34e2&scoped=true"
import script from "./DashboardUsageChart.vue?vue&type=script&lang=js"
export * from "./DashboardUsageChart.vue?vue&type=script&lang=js"
import style0 from "./DashboardUsageChart.vue?vue&type=style&index=0&id=f96e34e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f96e34e2",
  null
  
)

export default component.exports